import dayjs from 'dayjs';
const DATE_STRING_FORMAT = 'YYYY-MM-DD';
export const toDate = (dateString) => dayjs.utc(dateString, DATE_STRING_FORMAT);
export const fromDate = (date) => date.utc().format(DATE_STRING_FORMAT);
//# sourceMappingURL=DateString.js.map